import { useIsFetching } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { BoardPage } from '../../components/BoardPage.js';
import type { MediaKpi } from '../../components/media/data/types.js';
import { MediaBoard } from '../../components/media/MediaBoard.js';
import { type MediaSearch, validateMediaSearch } from '../../lib/media-search.js';
import { PagePrintAction } from '../../print/PagePrintAction.js';

function MediaPrintAction({ kpiOptions }: { kpiOptions: MediaKpi[] }): ReactNode {
  const isFetchingReport = useIsFetching({
    predicate: ({ queryKey }) => {
      const path = queryKey[0];
      return Array.isArray(path) && (path[0] === 'mediaPerformance' || path[0] === 'filters');
    },
  });

  return <PagePrintAction disabled={kpiOptions.length === 0 || isFetchingReport > 0} />;
}

function MediaPage(): ReactNode {
  return (
    <BoardPage
      route="/media"
      active="reports"
      contentSx={{ p: 6 }}
      topBarActions={({ kpiOptions }) => <MediaPrintAction kpiOptions={kpiOptions} />}
    >
      {(board) => <MediaBoard {...board} />}
    </BoardPage>
  );
}

export const Route = createFileRoute('/media/')({
  validateSearch: (search: Record<string, unknown>): MediaSearch => validateMediaSearch(search),
  component: MediaPage,
});
